import { fromJS } from 'immutable'
import {
  USER_CREATE_REQUEST,
  USER_CREATE_SUCCESS,
  USER_CREATE_FAILURE,
  USER_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case USER_CREATE_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Created Successfully')
        .set('message', 'The data had successfully been updated')
        .set('employeeCreate', fromJS(action.payload.createdUser))
    case USER_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('employeeCreate', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case USER_CREATE_RESET:
      return state
        .delete('employeeCreate')
        .delete('type')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-create-reducer.js